<h2 class="evn-text-subhead-2">Resources</h2>

<section class="cg-margin-top-lg">
  <div class="row" style="row-gap: 1em">
    <ng-container *ngFor="let resource of links">
      <div class="col-md-3">
        <div class="cg-margin-bottom-md cg-margin-right-md">
          <div class="evn-text-subhead-3">
            {{ resource.title }}
          </div>
          <div class="cg-margin-top-sm">{{ resource.body }}</div>
          <div class="cg-margin-top-sm">
            <a
              *ngIf="resource.resourceContext !== 'external'"
              [href]="
                resource.url
                  | resourceLink
                    : {
                        secure: false,
                        type: resource.linkType,
                        targetApp: resource.resourceContext
                      }
                  | async
              "
              target="resourcesWindow"
              [cignaTrackClicks]="[
                'trackEventOther',
                resource.urlName,
                'ac22398',
                {
                  eVar120: 'login-resources-links',
                  eVar119: 'US1881007'
                }
              ]"
              >{{ resource.urlName }}</a
            >
            <a
              *ngIf="resource.resourceContext === 'external'"
              [href]="resource.url"
              target="_blank"
              [cignaTrackClicks]="[
                'trackEventOther',
                resource.urlName,
                'ac22398',
                {
                  eVar120: 'login-resources-links',
                  eVar119: 'US1881007'
                }
              ]"
              >{{ resource.urlName }}</a
            >
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</section>
